import { Component, Input } from '@angular/core';

import { SMS_REPLY_PATTERN } from '../constants';
import { DYNAMICFIELDS } from '../../constants';

@Component({
  selector: 'chat-counter',
  templateUrl: './chat-counter.component.html',
  styleUrls: ['./chat-counter.component.scss'],
})
export class ChatCounterComponent {
  @Input() maxAnsiChars?: number;
  @Input() maxNonAnsiChars?: number;

  chars = 0;
  maxChars = 0;

  @Input() set chats(val: string) {
    this.chars = this.notificationLength(val);
    this.maxChars = this.chartsLength(val);
  }

  notificationLength(str: string): number {
    const _str = typeof str === 'string' ? str : '';
    let len = _str.length;
    DYNAMICFIELDS.forEach((field) => {
      if (_str.indexOf(`{${field.name}}`) !== -1) {
        len += field.defaultLength - `{${field.name}}`.length;
      }
    });

    return len;
  }

  chartsLength(str: string): number {
    const gsmRegExp = new RegExp(SMS_REPLY_PATTERN);

    return gsmRegExp.test(str) ? this.maxAnsiChars : this.maxNonAnsiChars;
  }
}
